import { render } from "./PageHeader.vue?vue&type=template&id=f7f9de3e&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=f7f9de3e&scoped=true&lang=css"
import "./PageHeader.vue?vue&type=style&index=1&id=f7f9de3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f9de3e"]])

export default __exports__